import { Injectable } from '@angular/core'

import { Observable, of } from 'rxjs'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'
import { MergePersonaModalSubmitter } from '../../lib/merge-persona-modal/merge-persona-modal-submit.service'

@Injectable({
  providedIn: 'root'
})
export class DocsMergePersonaModalSubmitter extends MergePersonaModalSubmitter {
  public error: string

  public submit(keepProfile: UserProfile, mergeProfile: UserProfile, description: string): Observable<UserProfile> {
    console.log('submit', keepProfile, mergeProfile, description)
    return of(mergeProfile)
  }
}
